var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('infinity-snackbar'),_c('infinity-invalidate-session'),_c('infinity-confirm',{ref:"confirm"}),(_vm.infinityLoading)?_c('infinity-loading'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }